import moment from "moment";
import { useState } from "react";
import { DatePicker, Modal, TextInput } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";

interface StatusChangedToHoldModalProps {
  onClose: () => void;
  onSave: (selectedDate: Date) => void;
  loading?: boolean;
}

const StatusChangedToHoldModal = (props: StatusChangedToHoldModalProps) => {
  const { loading = false } = props;
  const [date, setDate] = useState<Date | null>(null);
  return (
    <Modal
      dialogId={ModalId.STATUS_CHANGED_TO_HOLD_MODAL}
      title="Status Changed"
      onCancel={props.onClose}
      onClose={props.onClose}
      onSave={() => {
        if (date) {
          props.onSave(date);
        }
      }}
      saveButtonText={loading ? "Saving..." : "Save"}
      cancelText="Cancel"
      disableSave={loading || !date}
    >
      <div className="flex flex-col gap-2 p-4">
        <div className="text-sm font-normal text-primaryGray-1">
          Please select the date upto which the order should be on hold
        </div>
        <TextInput
          id="date"
          label="Select the date"
          defaultValue={date ? moment(date).format("DD MMM YYYY") : ""}
          readOnly
          onChange={(data) => {}}
        />
        <DatePicker
          initialDate={date ? new Date(date) : new Date()}
          onDateChange={(date) => {
            setDate(date);
          }}
        />
      </div>
    </Modal>
  );
};

export default StatusChangedToHoldModal;
